<div class="p-10">
    <router-outlet></router-outlet>
<!--    <app-doctors-list [doctors]="doctors" (open)="openDoctor()"/>-->
</div>
